import { render, staticRenderFns } from "./FundingCard.vue?vue&type=template&id=6bad0d67&scoped=true&"
import script from "./FundingCard.vue?vue&type=script&lang=js&"
export * from "./FundingCard.vue?vue&type=script&lang=js&"
import style0 from "./FundingCard.vue?vue&type=style&index=0&id=6bad0d67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bad0d67",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VCol,VIcon,VProgressLinear,VRow})
